"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMedia = _interopRequireDefault(require("react-media"));
var _hooks = require("../../helpers/hooks");
var _utilities = require("../../helpers/utilities");
var ResponsiveWrapper = function ResponsiveWrapper(_ref) {
  var children = _ref.children,
    breakpoint = _ref.breakpoint,
    mobileWrapper = _ref.mobileWrapper,
    desktopWrapper = _ref.desktopWrapper;
  var key = (0, _hooks.useKeyHack)();
  var DesktopWrapper = function DesktopWrapper(props) {
    return desktopWrapper(props);
  };
  var MobileWrapper = function MobileWrapper(props) {
    return mobileWrapper(props);
  };
  return /*#__PURE__*/_react["default"].createElement(_reactMedia["default"], {
    key: key,
    query: {
      minWidth: breakpoint
    },
    defaultMatches: (0, _utilities.isUserAgentSignallingMobile)()
  }, function (matches) {
    return matches ? /*#__PURE__*/_react["default"].createElement(DesktopWrapper, null, children({
      matches: matches
    })) : /*#__PURE__*/_react["default"].createElement(MobileWrapper, null, children({
      matches: matches
    }));
  });
};
ResponsiveWrapper.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].func]).isRequired,
  breakpoint: _propTypes["default"].number.isRequired,
  mobileWrapper: _propTypes["default"].func.isRequired,
  desktopWrapper: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ResponsiveWrapper;